import { computed } from "vue";
import { useSettings } from "@/composables/shared/useSettings";

const shellClass =
  "tw:bg-primary tw:text-white tw:dark:bg-surface-muted tw:dark:text-on-surface tw:dark:border-r tw:dark:border-on-surface/10";

const controlSurfaceClass = "tw:!bg-white/15 tw:dark:!bg-liteDef5";
const controlSurfaceSubtleClass = "tw:!bg-white/10 tw:dark:!bg-liteDef5";
const mutedIconClass = "tw:text-white/50 tw:dark:text-on-surface/50";
const closeIconClass = "tw:text-white/80 tw:dark:text-on-surface/80";

const tabBtnClass = (active: boolean) =>
  active
    ? "tw:dark:!bg-primary/15 tw:dark:!text-on-surface"
    : "tw:dark:!bg-transparent tw:dark:!text-on-surface/70";

/**
 * Visual shell styles for the chat dock sidebar (background, borders, controls, tabs).
 *
 * "Chrome" here means UI framing — not the browser. Pair with `useChatDock` for behavior
 * (search, tabs, selection); this composable only handles light/dark appearance classes.
 */
export function useChatDockChrome() {
  const { isDarkMode } = useSettings();

  const dividerColor = computed(() => (isDarkMode.value ? undefined : "white"));

  const inputColor = computed(() => (isDarkMode.value ? undefined : "white"));

  const tabBtnColor = (active: boolean) => {
    if (isDarkMode.value) return undefined;
    return active ? "primaryLighter" : "primary";
  };

  return {
    isDarkMode,
    shellClass,
    controlSurfaceClass,
    controlSurfaceSubtleClass,
    mutedIconClass,
    closeIconClass,
    dividerColor,
    inputColor,
    tabBtnColor,
    tabBtnClass,
  };
}
